unable to read source [project]/node_modules/@finbackoffice/enums/src/document.ts